/* A-Ljus collection page: 3 / 5 per row toggle and "Visa fler" (load more). */
if (!customElements.get('aljus-collection-view')) {
  const VIEW_KEY = 'aljus-collection-columns';

  class AljusCollectionView extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);

      let view = '3';
      try {
        view = localStorage.getItem(VIEW_KEY) || '3';
      } catch (e) {}
      this.setView(view);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const viewButton = event.target.closest('[data-aljus-view]');
      if (viewButton) {
        this.setView(viewButton.dataset.aljusView, true);
        return;
      }

      // The grid is re-rendered by facets.js, so the button is looked up on every click.
      const loadMoreButton = event.target.closest('[data-aljus-loadmore-btn]');
      if (loadMoreButton) {
        event.preventDefault();
        this.loadMore(loadMoreButton);
      }
    }

    setView(view, persist = false) {
      if (view !== '3' && view !== '5') view = '3';
      this.classList.toggle('aljus-collection--cols-5', view === '5');
      this.querySelectorAll('[data-aljus-view]').forEach((button) => {
        const active = button.dataset.aljusView === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active);
      });
      if (persist) {
        try {
          localStorage.setItem(VIEW_KEY, view);
        } catch (e) {}
      }
    }

    async loadMore(button) {
      if (button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      const url = new URL(button.href, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(url.toString());
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = this.querySelector('#product-grid');
        const newItems = html.querySelectorAll('#product-grid > li');
        const firstNewItem = newItems[0];

        newItems.forEach((item) => {
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          grid.appendChild(item);
        });

        const current = this.querySelector('[data-aljus-loadmore]');
        const next = html.querySelector('[data-aljus-loadmore]');
        if (current && next) {
          current.replaceWith(next);
        } else if (current) {
          current.remove();
        }

        // Move focus to the first new product for keyboard and screen reader users.
        const focusTarget = firstNewItem && firstNewItem.querySelector('a[href]:not([tabindex="-1"])');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      } catch (error) {
        // Fall back to a normal page load.
        window.location.href = button.href;
      }
    }
  }

  customElements.define('aljus-collection-view', AljusCollectionView);
}

/* Price filter as preset ranges: one active range fills the hidden min/max inputs read by facets.js. */
if (!customElements.get('aljus-price-buckets')) {
  const countCache = new Map();

  class AljusPriceBuckets extends HTMLElement {
    connectedCallback() {
      this.gteInput = this.querySelector('[data-price-gte]');
      this.lteInput = this.querySelector('[data-price-lte]');
      this.onInput = this.onInput.bind(this);
      // Runs before the form's own (debounced) input listener, so the hidden fields are ready.
      this.addEventListener('input', this.onInput);
      this.loadCounts();
    }

    disconnectedCallback() {
      this.removeEventListener('input', this.onInput);
    }

    get boxes() {
      return Array.from(this.querySelectorAll('input[type="checkbox"][data-gte]'));
    }

    onInput(event) {
      const box = event.target.closest('input[data-gte]');
      if (!box) return;

      this.boxes.forEach((other) => {
        if (other !== box) other.checked = false;
        other.closest('label').classList.toggle('active', other.checked);
      });

      this.gteInput.value = box.checked ? box.dataset.gte : '';
      this.lteInput.value = box.checked ? box.dataset.lte : '';
    }

    // Counts respect every other active filter, but not the price itself.
    async loadCounts() {
      const base = new URLSearchParams(window.location.search);
      [this.gteInput.name, this.lteInput.name, 'page', 'sort_by', 'section_id'].forEach((key) => base.delete(key));
      base.set('view', 'aljus-count');

      await Promise.all(
        this.boxes.map(async (box) => {
          const params = new URLSearchParams(base);
          if (box.dataset.gte) params.set(this.gteInput.name, box.dataset.gte);
          if (box.dataset.lte) params.set(this.lteInput.name, box.dataset.lte);
          const url = `${window.location.pathname}?${params.toString()}`;

          try {
            if (!countCache.has(url)) {
              countCache.set(
                url,
                fetch(url).then((response) => (response.ok ? response.text() : Promise.reject()))
              );
            }
            const count = parseInt(await countCache.get(url), 10);
            if (Number.isNaN(count)) return;

            const label = box.closest('label');
            label.querySelector('[data-bucket-count]').textContent = `(${count})`;
            const empty = count === 0 && !box.checked;
            label.classList.toggle('disabled', empty);
            box.disabled = empty;
          } catch (error) {
            countCache.delete(url);
          }
        })
      );
    }
  }

  customElements.define('aljus-price-buckets', AljusPriceBuckets);
}
